export enum EInsuranceStatus {
    PENDING = 'Pending',
    APPROVED = 'Approved',
    DENIED = 'Denied',
    APPEAL = 'Appeal',
}